import { render, staticRenderFns } from "./SuggestionsSection.vue?vue&type=template&id=143f3eed&scoped=true"
import script from "./SuggestionsSection.vue?vue&type=script&lang=ts"
export * from "./SuggestionsSection.vue?vue&type=script&lang=ts"
import style0 from "./SuggestionsSection.vue?vue&type=style&index=0&id=143f3eed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f3eed",
  null
  
)

export default component.exports